import React from 'react'
import { ProjectOverviewMenu } from './ProjectOverviewMenu'

interface ProjectOverviewImageCardMenuProps {
    onRestoreDefaultClick: (event: React.MouseEvent) => void
    onUploadImageClck: (event: React.MouseEvent) => void
    showRestoreDefault: boolean
}

const ProjectOverviewImageCardMenu: React.FC<ProjectOverviewImageCardMenuProps> = React.memo(
    ({ onRestoreDefaultClick, onUploadImageClck, showRestoreDefault }) => {
        const items = [{ text: 'Upload Image', onClick: onUploadImageClck, testId: 'liUploadImage' }]
        if (showRestoreDefault) {
            items.push({
                text: 'Restore Default',
                onClick: onRestoreDefaultClick,
                testId: 'liRestoreDefault'
            })
        }
        return <ProjectOverviewMenu items={items} />
    }
)

export default ProjectOverviewImageCardMenu
